import React, { Fragment, useEffect, useRef, useState } from "react"
import _ from 'lodash';
import { ExportFile } from "./ExportFile";
import { ImportFile } from "./ImportFile";
import { ListViewFilter } from "./ListViewFilter";
import PaginationBoxView from "./Pagination/PaginationBoxView";
import { ListViewProps } from "./ListView.props";
import { FxCheckbox } from "../checkbox/FxCheckbox";
import { FxButton } from "../button/FxButton";
import { FxInput } from "../input/FxInput";
import { getValue } from "../helpers";
import { FxIcon } from "../icon/FxIcon";
import { FxDateDisplay } from "../date-display/FxDateDisplay";
import { Box } from "@mui/material";

/**
 *
 * @param label
 * @param info
 * @constructor
 */
function Item(props: any) {
  const { children, divider, title } = props;
  return (
    <div className="m-left-2 d-flex" title={title}>
      {children}
      {divider &&
        <div className="divider-root"></div>
      }
    </div>
  );
}


function ToolbarModalWrapper(props: any) {
  const { openModal, id, iconId, children, icon } = props;
  return (
    <div className="modal-wrapper">
      <i id={iconId} className={`modal-action ${icon}`} onClick={openModal} />
      <div id={id} className="modal-background-shadow">
        <div className="modal-content">
          <div className="modal-container">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

let defaultFilter: any = {
  searchText: ''
};

export const ListView = (props: any) => {
  const { id, config, items, lookup } = props;
  const {
    mode = 'normal',
    canShowToolbar = false,
    canShowHeader,
    fieldDefs,
    toolSettings,
    exportConfig,
    pagerConfig,
    sorterConfig,
    rowSelection,
    filterConfig,
    defaultHeaderTemplate,
    defaultRowTemplate } = config;

  const className = config.className ? config.className : ''; // className:border-rows - each rows has border.
  const fieldTemplates = config.fieldTemplates ? config.fieldTemplates : '';

  const settingsConfig = toolSettings?.settingsConfig;

  const getColumnDefaults = (fieldDefsFromProps: any, settingsConfigFields: any) => {
    console.log('getColumnDefaults method');
    const fieldDefs = fieldDefsFromProps;
    let columnDisplayOrder: any = []
    if (settingsConfigFields && settingsConfigFields) {
      let result = [];
      let fields = _.orderBy(settingsConfigFields, ['displayOrder'], ['asc']);
      for (let item of fields) {
        let currentColumn = fieldDefs.find((i: any) => i.field == item.field);
        currentColumn.hidden = !item.selected;
        columnDisplayOrder.push(item.field);
        result.push(currentColumn);
      }
      return { columnDisplayOrder, fields: result };
    }
    return;
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [searchText, setSearchText] = useState("");
  const [canShowList, setToggleList] = useState(false);
  const defaultColumnOrder: any = [];
  const [columnOrder, setColumnOrder] = useState(defaultColumnOrder);
  const defaultColumns: any = fieldDefs;
  const [columns, setColumns] = useState(defaultColumns);
  const [itemCount, setItemCount] = useState(0);
  const defaultSettingsFields: any = [];
  const [settingsFields, setSettingsFields] = useState(defaultSettingsFields);

  useEffect(() => {
    const columnDefaults = getColumnDefaults(fieldDefs, toolSettings?.settingsConfig?.fields);
    if (columnDefaults) {
      setColumnOrder(columnDefaults.columnDisplayOrder);
      setColumns(columnDefaults.fields);
      setSettingsFields(toolSettings?.settingsConfig?.fields);
    }
  }, [toolSettings?.settingsConfig?.fields])

  useEffect(() => {
    let itemLength = items ? items.length : 0;
    setItemCount(itemLength);
  }, [items])

  //Pager related code starts
  let defaultPager: any = {
    startIndex: 0,
    pageCount: 0,
    pageNo: pagerConfig?.pageNo || 1,
    totalRecords: pagerConfig?.totalRecords || 0,
    pageSize: pagerConfig?.pageSize || 25,
    type: pagerConfig?.type,
    nextLabel: pagerConfig?.nextLabel || "next >",
    previousLabel: pagerConfig?.previousLabel || "< previous",
  };
  const [pager, setPager] = useState(defaultPager);

  useEffect(() => {
    let totalRecords: any = pagerConfig?.totalRecords || 0;
    let pageNo: any = pagerConfig?.pageNo || 0;

    let pageCount = Math.ceil(totalRecords / pager.pageSize);
    handlePagerChange({ pageCount, totalRecords: totalRecords, pageNo: pageNo });

    computePagerMsg(totalRecords, 0, pager.pageSize);

  }, [pagerConfig?.totalRecords])

  const computePagerMsg = (totalRecords: any, startIndex: any, pageSize: any) => {

    let startNo: any = 0;
    let endNo: any = 0;
    if (pagerConfig && totalRecords > 0) {

      //setting total items from result

      startNo = startIndex + 1;
      startNo = totalRecords == 0 ? 0 : startNo;

      endNo = startIndex + pageSize;
      endNo = endNo > totalRecords ? totalRecords : endNo;
    }

    let resultMsg = 'Showing ' + startNo + '-' + endNo + ' of ' + totalRecords + ' items';
    handlePagerChange({ pagerMsg: resultMsg });
  }

  const handlePagerChange = (data: any) => {
    setPager((prevState: any) => {
      return { ...prevState, ...data }
    });
  };

  const pageChanged = (event: any) => {
    handlePagerChange({ pageNo: event.selected + 1 });
    let startIndex = getStartIndex({ pageNo: event.selected + 1 });
    handlePagerChange({ startIndex: startIndex });

    computePagerMsg(pager.totalRecords, startIndex, pager.pageSize);

    if (pagerConfig?.pageChanged) {
      pagerConfig?.pageChanged({ pageNo: event.selected + 1, startIndex: startIndex })
    }
  };

  const getStartIndex = (options: any) => {
    let startIdx = 0;
    if (options && options.pageNo) {
      startIdx = options.pageNo === 1 ? 0 : ((options.pageNo - 1) * pager.pageSize);
    }
    return startIdx;
  }
  //Pager related code ends

  //Merge search filter and filterData from modal
  const handleSearchFilterChange = (item: any) => {
    setSearchText(item.value);
    if (toolSettings && toolSettings.search && toolSettings.search.onSearch) {
      toolSettings.search.onSearch(item);
    }
  }

  const toggleList = () => setToggleList(!canShowList)

  const prepareColumnOrder = () => {
    let columnDisplayOrder: any = []
    if (!(settingsConfig && settingsConfig.fields) && fieldDefs) {
      for (let fieldDef of fieldDefs) {
        if (fieldDef.field) {
          columnDisplayOrder.push(fieldDef.field)
        }
      }
      setColumnOrder(columnDisplayOrder)
    }
  }

  const defaultRowCheckboxIsSelected: any = false;
  const [isSelected, setIsSelected] = useState(defaultRowCheckboxIsSelected);
  const rowSelectionCallback = (item: any, row: any, rowIndex: any) => {
    setIsSelected(item.value);
    rowSelection?.rowSelectionCallback(item, row, rowIndex)
  }

  const defaultColumnHeaderSelectAllRecord: any = false;
  const [selectAllRecord, setSelectAllRecord] = useState(defaultColumnHeaderSelectAllRecord);
  const selectAllRecordCallback = (item: any, column: any) => {
    setSelectAllRecord(item.value);
    column.selectAllRecordCallback(item);
  }

  useEffect(() => {
    prepareColumnOrder();
    // Get the modal
    let modalElements = ['modal-filter-' + id, 'modal-import-' + id, 'modal-export-' + id];

    window.onclick = function (event) {
      for (let id in modalElements) {
        let element: any = modalElements[id];
        let res: any = document.getElementById(element);
        if (event.target == res) {
          res.style.display = "none";
        }
      }
    }
  }, []);

  // ListViewFilter starts
  const onApplyFilter = (data: any) => {
    let filterModel = data.filterModel;
    setFilter(filterModel);
    if (filterConfig?.filterChanged) {
      filterConfig.filterChanged({ filterModel });
    }
    onCancelModal(`modal-filter-${id}`);
  }
  // ListViewFilter end

  const openModal = (id: any) => {
    let res: any = document.getElementById(id);
    res.style.display = 'block';
  }

  const onCancelModal = (id: any) => {
    let res: any = document.getElementById(id);
    res.style.display = 'none';
  }

  const renderToolbar = () => <div id={`toolbar-${id}`} className="d-flex row-tmplt px-1 py-2">
    <div id={`toolbar-left-actions-${id}`} className="d-flex align-items-center">
      {filterConfig &&
        <Item divider={true}>
          <ToolbarModalWrapper id={`modal-filter-${id}`} iconId={`modal-filter-${id}-fa-filter`} icon="fas fa-filter" openModal={() => openModal(`modal-filter-${id}`)}>
            <ListViewFilter filterConfig={filterConfig}
              id={`listview-filter-${id}`}
              filterModel={filter}
              apply={(data: any) => { onApplyFilter(data) }}
              cancel={() => onCancelModal(`modal-filter-${id}`)}
              actionApply={filterConfig.actionApply}
              actionClose={filterConfig.actionClose}
              actionClear={filterConfig.actionClear}
            />
          </ToolbarModalWrapper>
        </Item>
      }
      {toolSettings && toolSettings.canExport &&
        <Item divider={true}>
          <ToolbarModalWrapper id={`modal-export-${id}`} iconId={`modal-export-${id}-fa-download`} icon="fas fa-download" openModal={() => openModal(`modal-export-${id}`)}>
            <ExportFile
              id={`listview-export-${id}`}
              onExport={toolSettings.onExport}
              onExportRequiredAlertMsg={toolSettings.onExportRequiredAlertMsg}
              fileName={toolSettings.exportFileName}
              cancel={() => onCancelModal(`modal-export-${id}`)} />
          </ToolbarModalWrapper>
        </Item>
      }
      {toolSettings && toolSettings.canUpload &&
        <Item divider={true}>
          <ToolbarModalWrapper id={`modal-import-${id}`} iconId={`modal-import-${id}-fa-upload`} icon="fas fa-upload" openModal={() => openModal(`modal-import-${id}`)}>
            <ImportFile
              id={`listview-import-${id}`}
              onImport={toolSettings.onImport}
              onImportRequiredAlertMsg={toolSettings.onImportRequiredAlertMsg}
              cancel={() => onCancelModal(`modal-import-${id}`)}
              fileSupportedMsg={toolSettings.fileSupportedMsg}
              noFileErrorMsg={toolSettings.noFileErrorMsg}
              chooseFileLbl={toolSettings.chooseFileLbl}
              fileUploadAction={toolSettings.fileUploadAction} />
          </ToolbarModalWrapper>
        </Item>
      }
      {toolSettings?.actions && toolSettings.actions.map((action: any, actionIndex: number) => (
        <Item title={action.text} divider={true} key={actionIndex}>
          <FxButton label={action.text} variant="contained" onClick={() => toolSettings?.handleTopBarAction(action)} />
        </Item>
      ))}
    </div>
    {toolSettings && toolSettings.headerTemplate &&
      <div id={`toolbar-header-template-${id}`} className={`toolbar-col d-flex mx-1 justify-content-${toolSettings.headerTemplateAlignment || 'end'}`}>
        {toolSettings.headerTemplate()}
      </div>
    }
    <div id={`toolbar-right-actions-${id}`} className="d-flex justify-content-end align-items-center">
      {toolSettings && toolSettings.search && toolSettings.search.allowSearch &&
        <Item divider={true}>
          <FxInput
            name={toolSettings.search.searchKey ? toolSettings.search.searchKey : "searchText"}
            label={filter.display}
            placeholder={toolSettings.search.searchPlaceholder ? toolSettings.search.searchPlaceholder : toolSettings.search.toolSettingsSearchlbl}
            value={searchText}
            variant="outlined"
            onValueChange={handleSearchFilterChange} />
        </Item>
      }
      {toolSettings && toolSettings.canShowToggle &&
        <Item>
          <span id={`toolbar-toggle-${id}`} onClick={toggleList} className="pointer">
            <i className={`fas fa-chevron-${canShowList ? 'down' : 'up'}`}></i>
          </span>
        </Item>
      }
    </div>
  </div>

  const getColClass = (item: any) => {
    let cls: any = item.size ? "col-" + item.size : "col";
    // if (item.sort) {
    //   cls = cls + " pointer";
    // }
    return cls;
  }

  const getStyle = (item: any) => {
    let obj: any = {};
    if (item.width) {
      obj.maxWidth = item.width;
      obj.flex = '0 0 ' + item.width + 'px';
      obj.padding = '3px 5px';
    }
    return obj;
  }

  const sort = (column: any) => {
    if (sorterConfig.sortable && column.sort) {
      sorterConfig?.onSortChanged(sorterConfig, column);
    }
  }

  const sortIcon = (column: any) => {
    if (column.field == sorterConfig.sortInfo?.name) {
      return sorterConfig.sortInfo?.direction == 'asc' ? 'sort-up' : 'sort-down';
    } else {
      return 'sort';
    }
  }

  //Render with header area starts
  const renderColumnHeader = (column: any) => <>
    {!column.hidden && (column.type == 'label' || column.type == 'date' || column.type == 'datetime' || column.type == 'lookup') &&
      <div title={column.title} className={`border-bottom pad-y-1 ${getColClass(column)} text-truncate`} style={getStyle(column)}>
        <div className="d-flex align-items-center justify-content-between text-truncate" style={{ width: "100%" }} onClick={() => sort(column)} >
          <div className={` ${column.align ? "text-" + column.align : ""} text-truncate col p-0 br-0`}>
            {column.title}
          </div>
          {column.sort &&
            <FxIcon icon={`fas fa-lg fa-${sortIcon(column)} pointer`} className="listview-sort" />
          }
        </div>
      </div>
    }
    {!column.hidden && (column.type == 'checkbox') && column.field &&
      <div className="border-bottom pad-y-1 col-1 d-flex justify-content-center">
        <FxCheckbox name={column.field} value={selectAllRecord} onValueChange={(item: any) => selectAllRecordCallback(item, column)} />
      </div>
    }
  </>

  const getLookupTypeRowValue = (fieldDef: any, row: any, lookup: any) => {
    let res: any = '';
    let obj: any = {};
    if (lookup && lookup[fieldDef.lookupKey] && lookup[fieldDef.lookupKey].length > 0) {
      const valueField = fieldDef.valueField || "code";
      const displayField = fieldDef.displayField || "text";
      obj = _.find(lookup[fieldDef.lookupKey], { [valueField]: row[fieldDef.field] });
      res = obj && obj[displayField] && obj[valueField] != "-1" ? obj[displayField] : "";
    }
    return <div title={res || ''} className={`border-bottom pad-y-1 ${getColClass(fieldDef)} text-truncate ${fieldDef.align ? 'text-' + fieldDef.align : ''}`} style={getStyle(fieldDef)}>
      {res}
    </div>
  }

  const getTypeBasedPathValue = (fieldDef: any, row: any) => <>
    {
      fieldDef.type == 'label' &&
      getValue(row, fieldDef.path)
    }
    {fieldDef.type == 'date' || fieldDef.type == 'datetime' &&
      <FxDateDisplay value={getValue(row, fieldDef.path)} displayType={fieldDef.type} />
    }
  </>

  const getTypeBasedFieldValue = (fieldDef: any, row: any) => <>
    {
      fieldDef.type == 'label' &&
      <>
        {row[fieldDef.field]}
      </>
    }
    {(fieldDef.type == 'date' || fieldDef.type == 'datetime') &&
      <>
        <FxDateDisplay value={row[fieldDef.field]} displayType={fieldDef.type} />
        {console.log("row[fieldDef.field] : ", row[fieldDef.field])}
      </>
    }
  </>

  const getLabelTypeRowValue = (fieldDef: any, row: any, index: any) => <>
    {
      fieldDef.path &&
      <div title={getValue(row, fieldDef.path) || ''} className={`border-bottom pad-y-1 ${getColClass(fieldDef)} text-truncate ${fieldDef.align ? 'text-' + fieldDef.align : ''}`} style={getStyle(fieldDef)}>
        {getTypeBasedPathValue(fieldDef, row)}
      </div>
    }
    {
      fieldDef.field &&
      <div title={!fieldTemplates[fieldDef.field] && row[fieldDef.field] ? row[fieldDef.field] : ''} className={`border-bottom pad-y-1 ${getColClass(fieldDef)} text-truncate ${fieldDef.align ? 'text-' + fieldDef.align : ''}`} style={getStyle(fieldDef)}>
        {fieldTemplates[fieldDef.field] && fieldTemplates[fieldDef.field]({ row, fieldDef, index: index })}
        {!fieldTemplates[fieldDef.field] &&
          <>
            {getTypeBasedFieldValue(fieldDef, row)}
          </>
        }
      </div>
    }
  </>

  // todo : issue in even class, eg page - vehicle agent list
  const renderRowWithHeader = ({ data, index, style, options }: any) => {
    const row: any = mode == 'virtualized' || mode == 'infinite' ? data[index] : data;
    return <div style={style}
      id={`row-with-header-${id}-${index}`}
      className={row && row.meta?.highlight ? "row listview-row-highlight m-0" : "row m-0"}>
      {rowSelection?.allowRowSelection &&
        <div className="border-bottom pad-y-1 col-1">
          <FxCheckbox name="isSelected" value={isSelected} onValueChange={(item: any) => rowSelectionCallback(item, row, index)} />
        </div>
      }
      {defaultRowTemplate && defaultRowTemplate(row, index)}
      {
        !defaultRowTemplate && columns && columns.map((fieldDef: any, colIndex: any) => (
          <Fragment key={colIndex}>
            {!fieldDef.hidden && fieldDef.type == 'checkbox' && fieldDef.field &&
              <div className="border-bottom pad-y-1 col-1 d-flex justify-content-center">
                {fieldTemplates[fieldDef.field] && fieldTemplates[fieldDef.field]({ row, fieldDef, index: index })}
                {!fieldTemplates[fieldDef.field] && row[fieldDef.field]}
              </div>
            }
            {!fieldDef.hidden && fieldDef.type == 'lookup' &&
              <>
                {getLookupTypeRowValue(fieldDef, row, lookup)}
              </>
            }
            {!fieldDef.hidden && fieldDef.type != 'lookup' &&
              <>{getLabelTypeRowValue(fieldDef, row, index)}</>
            }
          </Fragment>
        ))
      }
    </div >
  }

  const renderWithHeader = () => {
    return <div
      id={`with-header-${id}`}
      className={(mode == 'virtualized' || mode == 'infinite') ? "default-grid-react-virtual " + className : "default-grid " + className}
      style={canShowToolbar ? { height: "calc(100% - 57px)", maxHeight: "calc(100% - 57px)" } : { height: '100%' }}>
      {columns &&
        <div className="header row m-0">
          {rowSelection?.allowRowSelection && <div className="border-bottom pad-y-1 col-1">{rowSelection?.selectLbl}</div>}
          {columns.map((column: any, index: any) => (
            <Fragment key={index}>
              {renderColumnHeader(column)}
            </Fragment>
          ))
          }
        </div>
      }
      {mode == 'normal' && items && items.map((row: any, rowIndex: any) => (
        <Fragment key={rowIndex}>
          {renderRowWithHeader({ data: row, index: rowIndex, style: {} })}
        </Fragment>
      ))
      }

      {mode == 'normal' && (!items || items && items.length == 0) &&
        <div className="py-3 text-center">No records found</div>
      }
    </div>
  }
  //Render with header area ends

  //Render with custom header area starts
  const renderRowTemplate = ({ data, index, style, options }: any) => {
    const row: any = options.mode == 'virtualized' || mode == 'infinite' ? data[index] : data;
    return <div
      id={`row-template-${id}-${index}`}
      style={style} className={row && row.meta?.highlight ? "row listview-row-highlight m-0" : "row m-0"}>
      {options.rowSelection?.allowRowSelection &&
        <div className="border-bottom pad-y-1 col-1">
          <FxCheckbox name="isSelected" value={isSelected} onValueChange={(item: any) => rowSelectionCallback(item, row, index)} />
        </div>
      }
      {options.config.defaultRowTemplate && options.config.defaultRowTemplate(row, index)}
    </div>
  }

  const renderWithCustomHeader = () => <>
    {defaultHeaderTemplate &&
      <div className={(mode == 'virtualized' || mode == 'infinite') ? "default-grid-react-virtual " : "default-grid"}>
        {rowSelection?.allowRowSelection && <div className="border-bottom pad-y-1 col-1">{rowSelection?.selectLbl}</div>}
        {defaultHeaderTemplate()}

        {mode == "normal" && items && items.map((row: any, index: any) => (
          <Fragment key={index}>
            {renderRowTemplate({ data: row, index, style: {}, options: { ...props, mode } })}
          </Fragment>
        ))}
        {/*  {mode == "virtualized" && <div id={`virtualized`} className={className}>{RenderVirtualized(renderRowTemplate)}</div>}
       {mode == "infinite" && <div id={`infinite`} className={className}>{renderInfinite(renderRowTemplate)}</div>} */}
      </div>
    }

    {!defaultHeaderTemplate && <>
      {mode == "normal" && items && items.map((row: any, index: any) => (
        <Fragment key={index}>
          {renderRowTemplate({ data: row, index, style: {}, options: { ...props, mode } })}
        </Fragment>
      ))
      }
      {/*{mode == "virtualized" && <div id={`virtualized`} className={className} style={{ height: "calc(100% - 57px)", overflowY: 'auto' }}>{RenderVirtualized(renderRowTemplate)}</div>}
       {mode == "infinite" && <div id={`infinite`} className={className} style={{ height: "calc(100% - 57px)", overflowY: 'auto' }}>{renderInfinite(renderRowTemplate)}</div>} */}
    </>}
  </>

  const renderPagination = () => {
    return <div id={`react-paginate-${id}`} className="d-flex justify-content-between align-items-center m-top-2 react-paginate">
      <Box sx={{ marginRight: "15px", color: "#666" }}>{pager.pagerMsg ? pager.pagerMsg : ""}</Box>
      <PaginationBoxView
        id={`pagination-ul-${id}`}
        nextLabel={pager.nextLabel}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        breakLabel="..."
        forcePage={pager.pageNo - 1}
        onPageChange={pageChanged}
        pageCount={pager.pageCount}
        previousLabel={pager.previousLabel}
        renderOnZeroPageCount={null}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
      />
    </div>
  }

  return (
    <div className="listview" id={`listview-${id}`}>
      {exportConfig && exportConfig.canShowExportIcon &&
        <Box sx={{ textAlign: "right" }} className="m-bottom-1">
          <i className="pointer far fa-file-excel fa-lg text-success pointer" title="Export Excel" onClick={exportConfig.exportExcel}></i>
        </Box>
      }
      {canShowToolbar && renderToolbar()}
      {!canShowList &&
        <>
          {canShowHeader && renderWithHeader()}
          {!canShowHeader && renderWithCustomHeader()}
        </>
      }
      {pagerConfig && renderPagination() }
    </div>
  )
}
